<template>
    <div class="l-ss-c-results-empty-filters">
        <empty-results-header @reset-filters="$emit('reset-filters', $event)"/>
        <div
            class="l-ss-c-results-empty-filters-offers-wrapper"
            v-if="popularOffers.length">
            <offers-wrapper
                :view="view"
                :offer-layout="offerLayout"
                :breakpoint="currentBreakpoint"
                :offers="popularOffers"
                @add-to-cart-click="params => $emit('add-to-cart-click', params)"/>
        </div>
    </div>
</template>

<script>
    import { ref, onBeforeUnmount } from '@vue/composition-api';

    import iconFilterRemove from '@/core/assets/images/icons/filter-remove.svg';
    import OffersWrapper from '@/core/components/offers-wrapper.vue';

    import getCurrentBreakpoint from '@/core/helpers/get-current-breakpoint';
    import EmptyResultsHeader from '@/core/components/section-results/empty-results-header.js';

    export default {
        components: { EmptyResultsHeader, OffersWrapper },
        props: {
            popularOffers: {
                type: Array,
            },
            offerLayout: {
                type: String,
            },
            view: {
                type: String,
            },
            breakpoints: {
                type: Object,
            },
        },
        setup(props) {
            const currentBreakpoint = ref(null);

            const calcCurrentBreakpoint = () => {
                currentBreakpoint.value = getCurrentBreakpoint(props.breakpoints, window.innerWidth);
            };

            calcCurrentBreakpoint();

            window.addEventListener('resize', calcCurrentBreakpoint);

            onBeforeUnmount(() => {
                window.removeEventListener('resize', calcCurrentBreakpoint);
            });

            return {
                iconFilterRemove,
                currentBreakpoint,
            };
        },
    };
</script>
